<template>
  <b-modal
      v-model="visible"
      v-if="visible"
      hide-footer
      :no-close-on-backdrop="true"
      dialog-class="fm-modal"
      ref="fm-modal"
  >
    <file-manager-index
        :entity="entity"
        :selectable="selectable"
        :editable="editable"
        :active-type="activeType"
        @select="onSelectFile"
    />
  </b-modal>
</template>

<script>
import FileManagerIndex from "@/views/menu/file-manager/components/index.vue";

export default {
  name: "FileManagerModal",
  components: { FileManagerIndex },
  props: {
    value: { type: String, default: '' },
    entity: { type: [String, Number], default: null },
    show: { type: Boolean, default: false },
    selectable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    activeType: { type: String, default: 'all' }
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    selfValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) this.visible = true
      }
    },
    visible(val) {
      this.$emit('update:show', val)
    }
  },
  methods: {
    onSelectFile(file) {
      this.selfValue = file.Path
      this.$emit('select', file)
      this.visible = false
    }
  }
}
</script>

<style>
.fm-modal {
  max-width: 1100px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>